import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { CosellFilterConfig } from './filters/CosellFilterConfig';
export const CosellTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.CoSell], //CoSell
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: CosellFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: CosellFilterConfig,
      AreaPath: [UATConstants.McapsCoSellAreaPath],
      Title: UATConstants.TenantTitles.COSELL,
      ADOTitle: UATConstants.TenantADOText.COSELL,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateCosellRequest,
          Key: UATConstants.CreateActionMenuKey.CreateCosellRequest,
          NodeName: '',
        },
      ],
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: true,
      BulkEditConfig: [],
      BulkUpload: true,
      DownloadTemplate: true,
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'cosell',
        title: UATConstants.PlaceholdersAndTitles.CoSell,
        excelColumnSequence: {
          'Title': 1,
          'Action Owner': 2,
          'Assigned Team': 3,
          'CoSell_Activity': 4,
          'CoSell_DateAccepted': 5,
          'CoSell_DateExpired': 6,
          'CoSell_DealCreatedDate': 7,
          'CoSell_DealStatus': 8,
          'CoSell_DealValue': 9,
          'CoSell_DeliveryLanguageSupport': 10,
          'CoSell_ExpectedExpirationDate': 11,
          'CoSell_MCEMSalesStage': 12,
          'CoSell_MicrosoftOwner': 13,
          'CoSell_PartnerArea': 14,
          'CoSell_PartnerContactName': 15,
          'CoSell_PartnerCountry': 16,
          'CoSell_PartnerEmail': 17,
          'CoSell_PartnerEngaged': 18,
          'CoSell_PartnerRegion': 19,
          'CoSell_ReferralID': 20,
          'CoSell_RequestCategory': 21,
          'CoSell_SubCategoryTopic': 22,
          'Tags': 23,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'cosell_assignedto', formFieldLabel : UATConstants.PlaceholdersAndTitles.ActionOwner,apiFieldName: 'assignedto' },
        { formFieldName: 'cosell_microsoftowner', formFieldLabel : UATConstants.PlaceholdersAndTitles.MicrosoftOwner, apiFieldName: 'cosell_microsoftowner' }
      ], //Not in dynamic form & usePickerMandateError
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: true,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      systemViewsFolderId: '4b53b45d-4dc1-425e-813f-0d59c5bb9d02',
      sharedViewsFolderId: '9275b4c0-5e2b-4d9f-9f4f-940a9da71096',
    },
  },
};
